"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const postmessage_rpc_1 = require("@mixer/postmessage-rpc");
const tools_1 = require("./tools");
class CrossDomainCredentialStorage {
    constructor(credentialStorageUrl, serviceId, timeoutValue) {
        this.timeoutValue = timeoutValue;
        this.isIframeLoaded = false;
        const iframe = window.document.createElement('iframe');
        iframe.style.height = 0;
        iframe.style.width = 0;
        iframe.style.display = "none";
        iframe.name = 'authClientIframe';
        document.body.appendChild(iframe);
        const iframeWin = window.frames.authClientIframe;
        let rpc = new postmessage_rpc_1.RPC({
            target: iframeWin,
            serviceId,
        });
        rpc.expose('storageReady', () => {
            this.isIframeLoaded = true;
        });
        iframe.src = credentialStorageUrl;
        this.rpc = rpc;
    }
    delay(msec) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, msec);
        });
    }
    waitForIframe() {
        return __awaiter(this, void 0, void 0, function* () {
            while (!this.isIframeLoaded) {
                yield this.delay(100);
            }
        });
    }
    setCredentials(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield tools_1.promiseTimeout(this.timeoutValue, this.waitForIframe().then(res => {
                this.rpc.call('set', credentials);
            }));
        });
    }
    getCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield tools_1.promiseTimeout(this.timeoutValue, this.waitForIframe().then(res => {
                return this.rpc.call('get', {});
            }));
        });
    }
    clearCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield tools_1.promiseTimeout(this.timeoutValue, this.waitForIframe().then(res => {
                this.rpc.call('clear', {});
            }));
        });
    }
}
exports.default = CrossDomainCredentialStorage;
